/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

const stopAutoPlay = ( sliderObj ) => sliderObj.autoplay.stop();
const startAutoPlay = ( sliderObj ) => sliderObj.autoplay.start();

const setAnimationDuration = ( sliderObj, duration ) => {
  sliderObj.el.querySelectorAll( '.line-animator' )?.forEach( line => {
    line.style.animationDuration = `${duration}ms`;
  } );
};

const handleInteraction = ( swiper, navSwiper, el ) => {
  setAnimationDuration( navSwiper, 0 );
  stopAutoPlay( swiper );
  el.parentNode.classList.add( 'autoplay-stop' );
};

const handleDotsInteraction = ( swiper, navSwiper, el, dots ) => {
  dots.forEach( dot => {
    dot.addEventListener( 'click', () => {
      handleInteraction( swiper, navSwiper, el );
    } );
  } );
};
  
const handleArrowsInteraction = ( swiper, navSwiper, el, arrows ) => {
  arrows.forEach( arrow => {
    arrow.addEventListener( 'click', () => {
      handleInteraction( swiper, navSwiper, el );
    } );
  } );
};
  
const setupIntersectionObserver = ( el, swiper, navSwiper, settings ) => {
  const observer = new IntersectionObserver( ( entries ) => {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        el.parentNode.classList.add( 'tab-slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          startAutoPlay( swiper );
        }
        observer.unobserve( entry.target );
      } else {
        el.parentNode.classList.remove( 'tab-slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          stopAutoPlay( swiper );
        }
      }
    } );
  } );
  observer.observe( el );
};

function fillWithDuplicatesIfRequired( contentSwiper, navSwiper )
{
  const thumbSliderEl = navSwiper.el;
  const contentSliderEl = contentSwiper.el;
  const thumbSlides = thumbSliderEl.querySelectorAll( '.swiper-slide' );
  const contentSlides = contentSliderEl.querySelectorAll( '.swiper-slide' );
  const contentSliderSlidesToShow = 1.25;
  
  const swiperWrapper = ( el ) => el.querySelector( '.swiper-wrapper' );
  const minSlidesRequired = Math.ceil( 2 * contentSliderSlidesToShow ) + contentSlides.length;

  navSwiper.params.pagination = {
    el: '.swiper-pagination',
    type: 'custom',
    renderCustom: function ( swiper, current, total ) {
      const activeIndex = swiper.activeIndex;
      const currentSlide = swiper.slides[activeIndex];
      const duplicates = swiper.slides.filter( slide => slide.dataset.copyOf )
        .length;
      const currentSlideNumber = currentSlide.dataset.copyOf
        ? parseInt( currentSlide.dataset.copyOf ) + 1
        : swiper.realIndex + 1;

      const totalSlides = total - duplicates;
      return `
<span class="custom-fraction">${currentSlideNumber}/${totalSlides}</span>
`;
    },
  };
  // Fill up duplicate slides for loop
  if ( minSlidesRequired > contentSlides.length ) {
    let totalSlides = contentSlides.length;
    let thumbIndex = 0, contentIndex = 0;

    while ( totalSlides < minSlidesRequired ) {
      const clonedThumbSlider = thumbSlides[thumbIndex].cloneNode( true );
      clonedThumbSlider.dataset.copyOf = thumbIndex;

      const clonedContentSlider = contentSlides[contentIndex].cloneNode( true );
      clonedContentSlider.dataset.copyOf = contentIndex;

      swiperWrapper( thumbSliderEl ).append( clonedThumbSlider );
      swiperWrapper( contentSliderEl ).append( clonedContentSlider );

      thumbIndex = ( thumbIndex + 1 ) % thumbSlides.length;
      contentIndex = ( contentIndex + 1 ) % contentSlides.length;
      totalSlides++;
    }
  }
}

const initSliderContent = ( settings, el, swiper ) => {
  const navSwiper = swiper.thumbs.swiper;
  const isInfinite = settings.loop;
  const totalSlides = swiper.slides.length;
  
  
  if ( swiper.el.closest( '.e-tbs .e-tbs__content' ) ) {
    const animateDuration = settings.autoplay ? settings.autoplay.delay: 0;
    setAnimationDuration( navSwiper, animateDuration );

    stopAutoPlay( swiper );

    navSwiper.on( 'click', () => handleInteraction( swiper, navSwiper, el ) );
    swiper.on( 'touchEnd', () => handleInteraction( swiper, navSwiper, el ) );

    setupIntersectionObserver( el, swiper, navSwiper, settings );

    swiper.on( 'afterInit', ( swiper )=> {
      const arrows = swiper.el.querySelectorAll( '.e-tbs__btn' );
      const dots = swiper.el.querySelectorAll( '.swiper-pagination-bullet' );
      setAnimationDuration( swiper, animateDuration );
      handleDotsInteraction( swiper, navSwiper, el, dots );
      handleArrowsInteraction( swiper, navSwiper, el, arrows );
    } );
  }
  if ( swiper.el.closest( '.e-stn--client-success-posts .e-tbs__content' ) ) {
    navSwiper.on( 'slideChange', () => {
      const contentSliderSwiper = navSwiper.el.nextElementSibling.swiper;
      contentSliderSwiper.slideTo( navSwiper.activeIndex );
    } );
  }
  if( swiper.el.closest( '.e-stn--the-curated-team-delivery .e-tbs__content' ) && isInfinite && ( totalSlides < 4 ) ) {
    fillWithDuplicatesIfRequired( swiper, navSwiper );
  }
};

addAction( 'b3rg_tab_slider_content_init', 'b3rg/tab-slider', initSliderContent );
